export default {
  rooms: 'Zimmer:',
  area: 'Fläche:',
  ai_predictions_title: '📊 Prognostizierte Preisbewertungen durch KI',
  more: 'Mehr erfahren +',

  // 🏷 Transaktionstyp
  purpose: {
    sale: 'Zum Verkauf',
    rent: 'Zur Miete',
    short_term: 'Kurzzeitmiete'
  }
}
